import { render } from "./AppBlueBox.vue?vue&type=template&id=7bb585dd&scoped=true"
import script from "./AppBlueBox.vue?vue&type=script&lang=js"
export * from "./AppBlueBox.vue?vue&type=script&lang=js"

import "./AppBlueBox.vue?vue&type=style&index=0&id=7bb585dd&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb585dd"]])

export default __exports__